module.exports = __webpack_public_path__ + "img/tz.0d2e8cb4.svg";